import { CommonModule } from "@angular/common";

import {
  BatchUploadGuard,
  BroadcastsManagerGuard,
  ChannelCreatorGuard,
  LiveManagerGuard,
  MAMEditorGuard,
  MediaTranscoderGuard,
  RecordingManagerGuard,
  SuperUserGuard,
  UsersManagerGuard,
} from "./permission.guard";
import {
  ChannelActivateDeactivateGuard,
  ChannelEditScheduleGuard,
  ChannelEditSettingsGuard,
  ChannelViewGuard,
} from "./channels-guard.guard";
import { NgModule } from "@angular/core";

@NgModule({
  declarations: [],
  providers: [
    ChannelCreatorGuard,
    SuperUserGuard,
    BatchUploadGuard,
    RecordingManagerGuard,
    MAMEditorGuard,
    UsersManagerGuard,
    ChannelEditScheduleGuard,
    ChannelViewGuard,
    ChannelEditSettingsGuard,
    ChannelActivateDeactivateGuard,
    MediaTranscoderGuard,
    LiveManagerGuard,
    BroadcastsManagerGuard,
  ],
  imports: [CommonModule],
  exports: [],
})
export class EvrideoGuardsModule {}
